import { RootState } from "@/store/store";
import { infrastructureArchitectureDiagramEmptyDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramEmptyDataSelector";
import { infrastructureArchitectureDiagramLoadingSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramLoadingSelector";
import { infrastructureArchitectureRecommendationUninitializedSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationUninitializedSelector";
import { infrastructureArchitectureRecommendationDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationDataSelector";

export const infrastructureArchitectureRenderRecommendationDrawerSelector = (
  state: RootState,
) => {
  const recommendationUninitialized =
    infrastructureArchitectureRecommendationUninitializedSelector(state);
  const diagramDataEmpty =
    infrastructureArchitectureDiagramEmptyDataSelector(state);
  const diagramLoading =
    infrastructureArchitectureDiagramLoadingSelector(state);
  const data = infrastructureArchitectureRecommendationDataSelector(state);

  return (
    (!recommendationUninitialized || !!data) &&
    !diagramDataEmpty &&
    !diagramLoading
  );
};
